import { DevelopmentWorksheetDetails } from "@/model/employee-work-details/development-worksheet-details";
import { Component, OnInit } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { AppService } from "@services/app.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-development-worksheet-entry-form",
  templateUrl: "./development-worksheet-entry-form.component.html",
  styleUrl: "./development-worksheet-entry-form.component.scss",
})
export class DevelopmentWorksheetEntryFormComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  formId: number = 0;
  availableList: any;
  isReadOnly: boolean = false;
  wagsMonth: string = "";
  getAllWagsMonth: string[] = [];
  worksheetEntryDetails: DevelopmentWorksheetDetails[] = [];
  isCountReadyOnly: boolean = false;
  getAllWorkingTypeDetails: any[] = [];
  isUpdate: boolean = false;
  today: any;

  constructor(
    private appService: AppService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService
  ) {}

  addWorksheetEntryForm = new UntypedFormGroup({
    devEmployeeTrackId: new UntypedFormControl(0, [
      Validators.required,
      Validators.nullValidator,
    ]),
    formId: new UntypedFormControl(0, [
      Validators.required,
      Validators.nullValidator,
    ]),
    employeeName: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    wagesMonth: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    entryDate: new UntypedFormControl(0, [
      Validators.required,
      Validators.nullValidator,
    ]),
    startTime: new UntypedFormControl(0, [
      Validators.required,
      Validators.nullValidator,
    ]),
    endTime: new UntypedFormControl(0, [
      Validators.required,
      Validators.nullValidator,
    ]),
    totalHours: new UntypedFormControl(0, [
      Validators.required,
      Validators.nullValidator,
    ]),
    projectName: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    description: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    taskType: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    status: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    createdAt: new UntypedFormControl(0, [
      Validators.required,
      Validators.nullValidator,
    ]),
    createdBy: new UntypedFormControl(0, [
      Validators.required,
      Validators.nullValidator,
    ]),
    updatedAt: new UntypedFormControl(0, [
      Validators.required,
      Validators.nullValidator,
    ]),
    updatedBy: new UntypedFormControl(0, [
      Validators.required,
      Validators.nullValidator,
    ]),
  });

  public worksheetEntryFormErrors = {
    entryDate: "",
    startTime: "",
    endTime: "",
    projectName: "",
    description: "",
    totalHours: "",
    taskType: "",
  };

  ngOnInit() {
    this.getAllWorkingTypeList();
    this.getWagsMonthList();
    const decryptedFormId = atob(localStorage.getItem("formId") || "");
    this.formId = Number(decryptedFormId);
    this.addWorksheetEntryForm.controls["formId"].setValue(this.formId);
    const today = new Date();
    this.today = today.toLocaleDateString("en-GB"); // returns "dd/MM/yyyy"
    this.today = today.toISOString().split("T")[0];
    console.log(this.today);
    this.addWorksheetEntryForm.controls["entryDate"]?.setValue(this.today);
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onStartTimeChange() {
    const start = this.addWorksheetEntryForm.get("startTime")?.value;
    const end = this.addWorksheetEntryForm.get("endTime")?.value;

    if (start && end) {
      this.calculateTotalHours(start, end);
    }
  }

  onEndTimeChange() {
    const start = this.addWorksheetEntryForm.get("startTime")?.value;
    const end = this.addWorksheetEntryForm.get("endTime")?.value;

    if (start && end) {
      this.calculateTotalHours(start, end);
    }
  }

calculateTotalHours(start: string, end: string) {
  const startTime = new Date(`1970-01-01T${start}:00`);
  const endTime = new Date(`1970-01-01T${end}:00`);

  // Check if end time is greater than start time
  if (startTime >= endTime) {
    this.worksheetEntryFormErrors.totalHours =
      "*End time must be after start time";
    this.addWorksheetEntryForm.get("totalHours")?.setValue("");
    return;
  }

  // Calculate the difference in milliseconds
  const diffMs = endTime.getTime() - startTime.getTime();

  // Convert the difference to total minutes
  const totalMinutes = Math.floor(diffMs / (1000 * 60));

  // Calculate hours and remaining minutes
  const hours = Math.floor(totalMinutes / 60); // Total full hours
  const minutes = totalMinutes % 60; // Remaining minutes

  // Format the result as "HH:mm"
  const formattedTime = `${this.padZero(hours)}.${this.padZero(minutes)}`;

  // Set the total hours in "HH:mm" format
  this.worksheetEntryFormErrors.totalHours = "";
  this.addWorksheetEntryForm.get("totalHours")?.setValue(formattedTime);
}

// Helper function to pad single digit numbers with leading zero
padZero(value: number): string {
  return value < 10 ? `0${value}` : `${value}`;
}


  onSubmit() {
    this.formValidation();
  }

  formValidation() {
    // Reset all error messages
    this.worksheetEntryFormErrors = {
      startTime: "",
      endTime: "",
      entryDate: "",
      description: "",
      projectName: "",
      totalHours: "",
      taskType: "",
    };

    let hasError = false;

    // Validate each field individually and set specific error messages

    if (this.addWorksheetEntryForm.get("entryDate")?.value === 0) {
      this.worksheetEntryFormErrors.entryDate = "*Date is required";
      this.addWorksheetEntryForm.get("entryDate")?.markAsTouched();
      hasError = true;
    }

    if (this.addWorksheetEntryForm.get("projectName")?.invalid) {
      this.worksheetEntryFormErrors.projectName = "*Project name is required";
      this.addWorksheetEntryForm.get("projectName")?.markAsTouched();
      hasError = true;
    }

    if (this.addWorksheetEntryForm.get("taskType")?.invalid) {
      this.worksheetEntryFormErrors.taskType = "*Task type is required";
      this.addWorksheetEntryForm.get("taskType")?.markAsTouched();
      hasError = true;
    }


    if (this.addWorksheetEntryForm.get("description")?.invalid) {
      this.worksheetEntryFormErrors.description = "*Description is required";
      this.addWorksheetEntryForm.get("description")?.markAsTouched();
      hasError = true;
    }

    if (this.addWorksheetEntryForm.get("startTime")?.value === 0) {
      this.worksheetEntryFormErrors.startTime = "*start time is required";
      this.addWorksheetEntryForm.get("startTime")?.markAsTouched();
      hasError = true;
    }

    if (this.addWorksheetEntryForm.get("endTime")?.value === 0) {
      this.worksheetEntryFormErrors.endTime = "*End time is required";
      this.addWorksheetEntryForm.get("endTime")?.markAsTouched();
      hasError = true;
    }

    if (this.addWorksheetEntryForm.get("totalHours")?.value === 0) {
      this.worksheetEntryFormErrors.totalHours = "*Total horus is required";
      this.addWorksheetEntryForm.get("totalHours")?.markAsTouched();
      hasError = true;
    }

    const start = this.addWorksheetEntryForm.get("startTime")?.value;
    const end = this.addWorksheetEntryForm.get("endTime")?.value;

    if (start && end) {
      const startTime = new Date(`1970-01-01T${start}:00`);
      const endTime = new Date(`1970-01-01T${end}:00`);

      if (startTime >= endTime) {
        this.worksheetEntryFormErrors.endTime =
          "*End time must be after start time";
        hasError = true;
      }
    }

    if (!hasError) {
      this.saveAndUpdateWorkSheetDetails();
    }
  }

  /* Get work type list */
  getAllWorkingTypeList() {
    this.spinner.show();
    this.appService
      .getAllWorkingTypeList()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.getAllWorkingTypeDetails = data;
        },
        (error: any) => {
          this.toaster.error(
            error.error.message || "Something went wrong,please try again....."
          );
          this.spinner.hide();
        }
      );
  }

  /* Get wags month List */
  getWagsMonthList() {
    this.spinner.show();
    this.appService
      .getListOfWagsMonthForDevelopment()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          // Filter out empty strings
          this.getAllWagsMonth = data.filter((item) => item != "");

          this.getAllWagsMonth.sort((a, b) => {
            const dateA = new Date("01-" + a);
            const dateB = new Date("01-" + b);
            return dateB.getTime() - dateA.getTime();
          });

          // Set the first (latest) month
          this.wagsMonth = this.getAllWagsMonth[0];
          this.wagsMonthBasedDetailsGet(this.wagsMonth);
        },
        (error: any) => {
          this.toaster.error(
            error.error.message || "Something went wrong,please try again....."
          );
          this.spinner.hide();
        }
      );
  }

  enteredTotalImage(event: any) {
    const value = event.target.value;
    if (value == "" || value == 0) {
      this.isCountReadyOnly = true;
    } else {
      this.isCountReadyOnly = false;
    }
  }

  OnCalculate(event: any) {}

  /* Save employee worksheet entry */
  saveAndUpdateWorkSheetDetails() {
    const originalDate: Date =
      this.addWorksheetEntryForm.get("entryDate")?.value;
    const startTime = this.addWorksheetEntryForm.get("startTime")?.value;
    const endTime = this.addWorksheetEntryForm.get("endTime")?.value;

    // Convert date field
    const entryEpoch = new Date(originalDate).getTime();
    this.addWorksheetEntryForm.controls["entryDate"].setValue(entryEpoch);

    // Convert time fields to epoch (combine with entryDate)
    const baseDate = new Date(originalDate);
    const startEpoch = new Date(
      `${baseDate.toDateString()} ${startTime}:00`
    ).getTime();
    const endEpoch = new Date(
      `${baseDate.toDateString()} ${endTime}:00`
    ).getTime();

    this.addWorksheetEntryForm.controls["startTime"].setValue(startEpoch);
    this.addWorksheetEntryForm.controls["endTime"].setValue(endEpoch);
    this.spinner.show();
    let serviceUrl : any;
    if(this.isUpdate){
      serviceUrl = this.appService.updateDevelopmentWorkSheet(this.addWorksheetEntryForm.value);
    }else{
      serviceUrl = this.appService.saveDevelopmentWorkSheet(this.addWorksheetEntryForm.value);
    }
      serviceUrl.pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          if(this.isUpdate){
          this.toaster.success("Details updated successfully......");
          this.isUpdate = false;
          }else{
          this.toaster.success("Details saved successfully......");
          }
          this.addWorksheetEntryForm.reset();
          this.addWorksheetEntryForm.controls["entryDate"]?.setValue(
            this.today
          );
          this.getWagsMonthList();
        },
        (error: any) => {
          // Reset startTime and endTime to original string values if error
          this.addWorksheetEntryForm.controls["entryDate"].setValue(
            originalDate
          );
          this.addWorksheetEntryForm.controls["startTime"].setValue(startTime);
          this.addWorksheetEntryForm.controls["endTime"].setValue(endTime);

          this.toaster.error(
            error.error.message || "Something went wrong,please try again....."
          );
          this.spinner.hide();
        }
      );
  }

  /* get wags month based worksheet details  */
  wagsMonthBasedDetailsGet(month: string) {
    this.spinner.show();
    this.appService
      .wagsMonthBasedDetailsGetForDevelopment(month)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.worksheetEntryDetails = data.sort(
            (a, b) => b.devEmployeeTrackId - a.devEmployeeTrackId
          );
        },
        (error: any) => {
          this.toaster.error(
            error.error.message || "Something went wrong,please try again....."
          );
          this.spinner.hide();
        }
      );
  }
editEntryDetails(entry: DevelopmentWorksheetDetails) {
  // Convert entryDate from epoch to a readable date format (YYYY-MM-DD)
  const entryDate = new Date(entry.entryDate);
  const entryDateFormatted = entryDate.toISOString().slice(0, 10); // Get date part "YYYY-MM-DD"

  // Convert startTime and endTime from epoch to time format (HH:mm)
  const startDate = new Date(entry.startTime);
  const endDate = new Date(entry.endTime);

  // Check if the epoch values are in milliseconds, then format correctly
  const startTimeFormatted = this.formatTime(startDate);
  const endTimeFormatted = this.formatTime(endDate);

  // Now patch the form with the formatted values
  this.addWorksheetEntryForm.patchValue({
    ...entry,
    entryDate: entryDateFormatted,
    startTime: startTimeFormatted,
    endTime: endTimeFormatted,
  });

  this.isUpdate = true;
}

// Helper method to format the time in HH:mm
formatTime(date: Date): string {
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
}


  //Remove entry details function
  removeEntryDetails(devEmployeeTrackId: number,projectName : string) {
     this.spinner.show();
    this.appService
      .developmentWorksheetDeleteById(devEmployeeTrackId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.toaster.success(`${projectName} details removed successfully.`);
          this.wagsMonthBasedDetailsGet(this.wagsMonth)
        },
        (error: any) => {
          this.toaster.error(
            error.error.message || "Something went wrong,please try again....."
          );
          this.spinner.hide();
        }
      );
  }
}
